import moment from 'moment'
import Vue from 'vue'

export const capitalize = (value:any) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

Vue.filter('capitalize',capitalize)